/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
require('jquery-ui-dist/jquery-ui.min.js');
require('jquery-ui-touch-punch/jquery.ui.touch-punch.min.js');
require('@fancyapps/fancybox/dist/jquery.fancybox.min.js');
require('./assets/js/web.js');

require('icheck');
require('materialize-css');
require('jquery-mousewheel');

import "./assets/scss/fonts.scss";
import "./assets/scss/app.scss";
import 'tooltipster';
import 'tooltipster/dist/css/tooltipster.bundle.min.css';
import 'tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-borderless.min.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';


// import 'icheck/skins/square/_all.css';
// window._ = require('lodash');
window.jwtDecode = require('jwt-decode');
window.moment = require('moment');


window.App = {
	jwt: false,
	user: false,
	allowGtag: true,
	filters: false,
	search: false,
	OSID: false,
	notifications: false,
	platform: (navigator.platform.indexOf("iPhone") != -1 || navigator.platform.indexOf("iPod") != -1) ? 'ios' : 'android',
	conversation_id: 0,
	restApi: 'https://api.soundfeedapp.com',
    countryGroups: [
		{name: 'CIS', selected: false, countries: [16, 12, 21, 118, 122, 147, 186, 223, 233, 242, 237]},
		{name: 'Baltics', selected: false, countries: [72, 124, 130]},
		{name: 'GSA', selected: false, countries: [85, 220, 15]},
		{name: 'LATAM (Latin America)', selected: false, countries: [23, 57, 69, 93, 101, 145, 161, 173, 11, 27, 48, 52, 67, 175, 176, 241, 244, 66, 98, 181]},
		{name: 'France & DOM-TOM', selected: false, countries: [91, 97, 141, 144, 192, 80, 193, 246, 159]},
		{name: 'MENA (Middle East & North Africa)', selected: false, countries: [4, 18, 68, 108, 109, 117, 121, 125, 128, 152, 169, 172, 182, 198, 221, 231, 238, 248]},
		{name: 'South East Asia', selected: false, countries: [245, 123, 41, 225, 154, 136, 106, 203, 177, 226, 37, 222]},
		{name: 'Europe Union', selected: false, countries: [15, 22, 38, 58, 61, 62, 63, 72, 77, 78, 85, 88, 103, 110, 113, 124, 130, 131, 139, 158, 179, 180, 185, 205, 206, 213, 219, 239]},
		{name: 'Benelux', selected: false, countries: [22, 158, 131]}
	],
};
 
/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue').default;
require('vue-resource');
 
/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 */

Vue.http.interceptors.push((request, next) => {
    var tkn = localStorage.getItem('token');
    var current_time = Date.now() / 1000;

    if (window.App.jwt && window.App.jwt.exp > current_time) {
        request.headers.set('Authorization', 'Bearer ' + tkn);
    } else {
    	// router.push('/login');
        // return;
    }

    if (request.url.indexOf('https://url.soundfeedapp.com/generate') != -1){
    	request.headers.delete('x-socket-id');
    	request.headers.delete('authorization');
    }

    if (request.url.indexOf('https://i.imgur.com') != -1){
    	request.headers.delete('x-socket-id');
    	request.headers.delete('authorization');
    }

    if (request.url.indexOf('https://www.soundfeedapp.com/scripts/url-preview.php') != -1){
    	request.headers.delete('x-socket-id');
    	request.headers.delete('authorization');
    }

    if (request.url.indexOf('https://imgur-apiv3.p.rapidapi.com') != -1){
    	request.headers.set('Authorization', 'Bearer ef497a57d7d4d7fa7d7bf4aaf30302ad8e301d53');
    	request.headers.set('X-RapidAPI-Host', 'imgur-apiv3.p.rapidapi.com');
    	request.headers.set('X-RapidAPI-Key', '55ced47af8mshc534f31b27c81a8p1c70fdjsne8f7e7f74b9f');
    }


    next();

    /** do we need to check if token expired as request feedback ? */

	// next((response) => {
	// 	if(response.status == 401 ) {
	// 		Event.$emit('logout-unauthorized');
	// 		router.push('/login');
	// 		return;
	// 	}
	// });
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";
window.Pusher = require('pusher-js');


(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-38457291-8', 'auto');
ga('send', 'pageview')

import Application from './App.vue'
import router from './router'
 
window.Event = new Vue({
	router,
	render: function (h) { 
		return h( Application ) ;
	}
}).$mount('#app')